// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

import { bottom } from "src/core/DisplayLayoutKeys";

export default class TestButton {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    private _TestButton?: vf.gui.Button;
    private _buttonList: vf.gui.Label[] = [];
    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        vf.Loader.shared.add('assets/skin/Button/button_up.png').onComplete.once(()=>{
            const button = new vf.gui.Button;
            button.up = "assets/skin/Button/button_up.png";
            uiStage.addChild(button);
        });
        vf.Loader.shared.load();
        
        const button1 = this._TestButton = new vf.gui.Button;
        button1.useMoveEvent = true; // 开启移动上去的事件
        button1.style.left = 500;
        button1.style.top = 250;
        button1.style.width = 100;
        button1.style.height = 50;
        button1.textOffsetY = -10;

        button1.id = 'button';
        button1.text = "点我试试";
        button1.up = "assets/skin/Button/button_up.png";
        button1.down = "assets/skin/Button/button_down.png";
        button1.move = "assets/skin/Button/button_move.png";
        button1.disabled = "assets/pc.png";

        // button1.disabled=""; 
        uiStage.addChild(button1);


        function hoverFun(a: any, b: any, c: any, d: any, e: any) {
            console.log('move');
            console.log(a);
            console.log(b);
            console.log(c);
            console.log(d);
            console.log(e);
        }

        function hoverFun2(a: any, b: any, c: any, d: any, e: any) {
            console.log('down');
            console.log(a);
            console.log(b);
            console.log(c);
            console.log(d);
            console.log(e);
        }

        function hoverFun3(a: any, b: any, c: any, d: any, e: any) {
            console.log('up');
            console.log(a);
            console.log(b);
            console.log(c);
            console.log(d);
            console.log(e);
        }

        function hoverFun4(a: any, b: any, c: any, d: any, e: any) {
            console.log('click');
            console.log(a);
            console.log(b);
            console.log(c);
            console.log(d);
            console.log(e);
        }

        function hoverFun5(a: any, b: any, c: any, d: any, e: any) {
            console.log('press');
            console.log(a);
            console.log(b);
            console.log(c);
            console.log(d);
            console.log(e);
        }

        function hoverFun6(a: any, b: any, c: any, d: any, e: any) {
            console.log('hover');
            console.log(a);
            console.log(b);
            console.log(c);
            console.log(d);
            console.log(e);
        }


        this.getButton('设置/取消 text', () => {

            if (button1.text !== "Hello World") {
                button1.text = "Hello World";

            } else {
                button1.text = "点我试试";

            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 up 皮肤', () => {
            if (button1.up !== "") {
                button1.up = "";
            } else {
                button1.up = "assets/skin/Button/button_up.png";
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 down 皮肤', () => {
            if (button1.down !== "") {
                button1.down = "";
            } else {
                button1.down = "assets/skin/Button/button_down.png";
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 move 皮肤', () => {
            if (button1.move !== "") {
                button1.move = "";
            } else {
                button1.move = "assets/skin/Button/button_move.png";
            }

        }, uiStage, 15, 0);

        let b4 = true;
        this.getButton('设置/取消 click 事件', () => {
            if (!b4) {
                b4 = true;
                button1.off(vf.gui.Interaction.TouchMouseEvent.onClick, hoverFun4);

            } else {
                b4 = false;
                button1.on(vf.gui.Interaction.TouchMouseEvent.onClick, hoverFun4);
            }
        }, uiStage, 15, 0);



        let b = true;
        this.getButton('设置/取消 move 事件', () => {
            if (!b) {
                b = true;
                button1.useMoveEvent = true;
                button1.on(vf.gui.Interaction.TouchMouseEvent.onMove, hoverFun);

            } else {
                b = false;
                button1.off(vf.gui.Interaction.TouchMouseEvent.onMove, hoverFun);

            }
        }, uiStage, 15, 0);


        let b2 = true;
        this.getButton('设置/取消 down 事件', () => {
            if (!b2) {
                b2 = true;
                button1.on(vf.gui.Interaction.TouchMouseEvent.onDown, hoverFun2);

            } else {
                b2 = false;
                button1.off(vf.gui.Interaction.TouchMouseEvent.onDown, hoverFun2);
            }
        }, uiStage, 15, 0);

        let b3 = true;
        this.getButton('设置/取消 up 事件', () => {
            if (!b3) {
                b3 = true;
                button1.off(vf.gui.Interaction.TouchMouseEvent.onUp, hoverFun3);

            } else {
                b3 = false;
                button1.on(vf.gui.Interaction.TouchMouseEvent.onUp, hoverFun3);
            }
        }, uiStage, 15, 0);

        let b5 = true;
        this.getButton('设置/取消 press 事件', () => {
            if (!b5) {
                b5 = true;
                button1.off(vf.gui.Interaction.TouchMouseEvent.onPress, hoverFun5);

            } else {
                b5 = false;
                (button1 as any)['double'] = true;
                button1.on(vf.gui.Interaction.TouchMouseEvent.onPress, hoverFun5);
            }
        }, uiStage, 15, 0);


        let b6 = true;
        this.getButton('设置/取消 hover 事件', () => {
            if (!b6) {
                b6 = true;
                button1.off(vf.gui.Interaction.TouchMouseEvent.onHover, hoverFun6);

            } else {
                b6 = false;
                button1.on(vf.gui.Interaction.TouchMouseEvent.onHover, hoverFun6);
            }
        }, uiStage, 15, 0);

        let b7 = true;
        this.getButton('设置/取消 double 事件', () => {
            if (!b7) {
                b7 = true;
                button1.off('double');

            } else {
                b7 = false;
                (button1 as any).double = true;
                button1.on('double',()=>{
                    console.log('double');
                });
            }
        }, uiStage, 15, 0);

    }

    private posY = 10;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;
        this._buttonList.push(button);
        return button;
    }

    private onRelease() {
        if (this._TestButton) {
            this._TestButton.removeAllListeners();
            this._TestButton.parent && this._TestButton.parent.removeChild(this._TestButton);
            this._TestButton.release();
            this._TestButton = undefined;
        }
        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }







}

